/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FeiertagDto } from '../../models/feiertag-dto';

export interface GetFeiertageByYear$Plain$Params {

/**
 * Jahr von dem die Feiertage benötigt werden
 */
  jahr: number;

/**
 * Optionale ID für einen Mitarbeiter
 */
  mitarbeiterId?: string;
}

export function getFeiertageByYear$Plain(http: HttpClient, rootUrl: string, params: GetFeiertageByYear$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FeiertagDto>>> {
  const rb = new RequestBuilder(rootUrl, getFeiertageByYear$Plain.PATH, 'get');
  if (params) {
    rb.path('jahr', params.jahr, {});
    rb.query('mitarbeiterId', params.mitarbeiterId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FeiertagDto>>;
    })
  );
}

getFeiertageByYear$Plain.PATH = '/v1/feiertage/{jahr}';
